import React, { useEffect, useState } from "react";
import { Badge, Card, CardBody, CardTitle, Row } from "reactstrap";
import { Colxx } from "../../../components/common/CustomBootstrap";
import IntlMessages from "../../../helpers/IntlMessages";
import axios from "axios";
import { END_POINT } from "../../../constants/defaultValues";

const PERMISSION_LABELS = new Map([
  ["R", "Xem"],
  ["C", "Thêm"],
  ["U", "Sửa"],
  ["D", "Xóa"],
  ["F", "Toàn quyền"],
  ["RBD", "Xem ngày cụ thể"],
  ["RC", "Xem và so sánh"],
  ["ACE", "Administrator"],
]);

const getPermissionLabel = (permission) => {
  return PERMISSION_LABELS.get(permission) || permission;
};

const ContentDisplay = (props) => {
  const [roleMap, setRoleMap] = useState(new Map());

  useEffect(() => {
    const tokenStr = localStorage.getItem("access_token");
    axios
      .get(`${END_POINT}/user-role/role`, {
        headers: { Authorization: `Bearer ${tokenStr}` },
      })
      .then((res) => res.data)
      .then((data) => {
        const map = new Map();
        if (data.data && Array.isArray(data.data)) {
          data.data.forEach((role) => {
            map.set(role.alias, role.name);
          });
        }
        setRoleMap(map);
      })
      .catch(() => {});
  }, []);

  const removeDuplicate = [
    ...new Set(props.values.settings.map((e) => e.role_alias)),
  ];

  const getRoleName = (alias) => {
    return roleMap.get(alias) || alias.replace(/_/g, " ");
  };

  return (
    <Card className="mb-4">
      <CardBody>
        <CardTitle>
          <IntlMessages id="role.title" />
        </CardTitle>
        <Row className="mt-3">
          <Colxx xxs="12" lg="6">
            <p className="text-muted text-small mb-2">
              <IntlMessages id="name" />
            </p>
            <p className="mb-3 text-capitalize">
              {props.values.name ? (
                props.values.name
              ) : (
                <span className="text-lowercase">(Chưa có thông tin)</span>
              )}
            </p>
          </Colxx>
        </Row>
        {removeDuplicate.map((el, idx) => {
          return (
            <Row key={idx}>
              <Colxx xxs="12" lg="4">
                <p className="text-muted text-small mb-2">{getRoleName(el)}</p>
              </Colxx>
              <Colxx xxs="12" lg="8" className="d-flex align-items-center">
                {props.values.settings
                  .filter((e) => e.role_alias === el)
                  .map((item, idx) => {
                    return (
                      <Colxx key={idx} xxs="12" lg="2">
                        <Badge color="primary" className="mb-2">
                          {getPermissionLabel(item.permission)}
                        </Badge>
                      </Colxx>
                    );
                  })}
              </Colxx>
            </Row>
          );
        })}
      </CardBody>
    </Card>
  );
};

export default ContentDisplay;
